module.exports = __webpack_public_path__ + "media/fonts/fa-brands-400-2692345e458ff151944c1d3879eace8a.woff2";